import { useContext, useRef, useState } from "react";
import { Modal, Form, Button, Row, Col, Input, DatePicker, message } from "antd";
import { GlobalState } from "./../../../../context/globalState";
import Images from "./../../../../asset/exportImages";
import Package from "./../../../../components/package";
import Server from "./../../../../lib/getAPI";
import dayjs from "dayjs";
import { trackProductEvent } from '../../../../lib/trackingService';

function AdAndEdit({ handelCanCel, idEdit }) {
  const { isMobile, ActionList, listOfInsuredPeople, dataOrder, Helper, messageErr, validatePeople } = useContext(GlobalState);
  const [form] = Form.useForm();
  const today = dayjs();
  const importInputRefCCCD = useRef();
  const minDate = today.subtract(75, "year");
  const maxDate = today.subtract(15, "days").add(1, 'days'); // 15 ngày tuổi
  const [loading, setLoading] = useState(false);
  const [linkPrivateIdUrl, setLinkPrivateIdUrl] = useState(listOfInsuredPeople?.[idEdit]?.privateIdUrl || undefined);

  const disabledDate = (current) => {
    if (!current) return false;
    return current.isBefore(minDate, "day") || current.isAfter(maxDate, "day");
  };

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        if (validatePeople(values.insuredPrivateId, idEdit)) {
          trackProductEvent("product_insurance_validation_failed", {
            error_code: "DUPLICATE_INSURED_PRIVATE_ID",
          });
          return;
        }
        if (idEdit === undefined) {
          ActionList('add', '', values);
        } else {
          ActionList('edit', idEdit, values);
        }
        handelCanCel();
      })
      .catch((err) => {
        trackProductEvent("product_insurance_validation_failed", {
          error_code: "INSURED_FORM_INVALID",
        });
        console.error("err:", err);
      });
  };

  const handleImportFile = async (files) => {
    if (!files?.[0]) return;
    trackProductEvent("product_insurance_file_upload", {
      file_type: "cccd_ocr",
    });
    setLoading(true);
    message.warning("Hình ảnh đang được xử lý!");

    try {
      // 1) Upload
      const uploadForm = new FormData();
      uploadForm.append("file", files[0]);
      uploadForm.append("productCode", "tnhgd");
      const uploadRes = await Server.apiCallOpenVerify("POST", "/v1/products/upload/private-id", uploadForm);
      const uploadData = uploadRes?.data;
      if (!uploadData?.success) throw new Error("Upload thất bại");

      const link = uploadData.data.url;

      // 2) OCR
      const ocrPayload = { privateIdFrontUrl: link };
      const ocrRes = await Server.apiCallOpenVerify("POST", "/v1/ocr/private-id", ocrPayload);
      const ocrData = ocrRes?.data;

      if (ocrData?.success) {
        setLinkPrivateIdUrl(link);
        form.setFieldsValue({ "privateIdUrl": link })
        const idInfo = ocrData.data?.idCardInfo || {};
        const dobFormat = idInfo.dob ? dayjs(idInfo.dob, "DD/MM/YYYY") : undefined;
        form.setFieldsValue({
          insuredName: idInfo?.name || undefined,
          insuredDob: dobFormat,
          insuredPrivateId: idInfo?.id || undefined,
          // insuredGender: idInfo?.gender ? idInfo?.gender == 'Nam' ? 'MALE' : 'FEMALE' : undefined
        })
        message.success('Hình ảnh được xử lý thành công!');
      } else {
        // trường hợp API trả lỗi dạng code
        if (ocrData?.code) messageErr(ocrData.code);
        else message.error("Xử lý OCR thất bại");
      }
    } catch (err) {
      if (err.response.data.message) {
        messageErr(err.response.data.statusCode, err.response.data.message);
      } else {
        message.error("Có lỗi xảy ra vui lòng kiểm tra lại!");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <input
        ref={importInputRefCCCD}
        type="file"
        accept="image/*"
        onClick={(e) => {
          e.target.value = "";
        }}
        onChange={(e) => handleImportFile(e.target.files)}
        style={{
          display: "none",
        }}
      />
      <Modal
        className="modal-filter"
        footer={false}
        open={true}
        centered={true}
        closable={true}
        maskClosable={false}
        onCancel={handelCanCel}
        style={{ minWidth: isMobile ? "" : 600 }}
      >
        <Form
          layout={"vertical"}
          scrollToFirstError
          form={form}
          onFinish={onFinish}
          onFinishFailed={() => {
            trackProductEvent("product_insurance_validation_failed", {
              error_code: "INSURED_FORM_INVALID",
            });
          }}
          requiredMark={(label, { required }) => (
            <>
              {label}
              {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
            </>
          )}
          initialValues={{
            ...listOfInsuredPeople?.[idEdit],
            "insuredName": idEdit !== undefined ? Helper.capitalize(listOfInsuredPeople?.[idEdit]?.insuredName) : undefined,
            "insuredDob": idEdit !== undefined ? dayjs(listOfInsuredPeople?.[idEdit]?.insuredDob) : undefined,
          }}
        >
          <Row gutter={[15, 15]}>
            <Col xl={24}>
              <div style={{ fontSize: 18, fontWeight: 600, marginTop: -5, textAlign: 'left' }}>
                Người được bảo hiểm
              </div>
            </Col>
            <Col xs={24}>
              <Package
                packagePrice={dataOrder.fees}
                logo={dataOrder?.urlIcon}
                packageAmount={dataOrder?.benefits?.totalFees}
                packageName={dataOrder?.title}
                commission={dataOrder?.commission}
              />
            </Col>
            <Col xs={24}>
              <div style={{ display: 'flex', gap: 10 }}>
                {
                  linkPrivateIdUrl &&
                  <div style={{ padding: 5, borderRadius: 10, border: '0.5px solid #D2D2D2', marginRight: isMobile ? 15 : 0, width: isMobile ? '50%' : 165, position: 'relative' }}>
                    <img width={isMobile ? '100%' : 165} height={105} src={linkPrivateIdUrl} style={{ objectFit: 'cover', borderRadius: 10, marginBottom: -5 }} />
                    <img onClick={() => {
                      form.setFieldsValue({ 'privateIdUrl': undefined });
                      setLinkPrivateIdUrl(undefined);
                    }} style={{ position: 'absolute', right: 10, top: 10, cursor: 'pointer' }} src={Images.ICXoa2} width={isMobile ? '16px' : '20px'} />
                  </div>
                }
                {
                  !linkPrivateIdUrl &&
                  <img onClick={() => importInputRefCCCD.current.click()} width={isMobile ? '50%' : 165} src={Images.CCCDMB} style={{ marginRight: isMobile ? 15 : 0, cursor: 'pointer' }} />
                }
                <div style={{ width: isMobile ? '50%' : '' }}>
                  <i style={{ fontSize: 12, color: '#FB7800' }}>
                    Chụp CCCD/hộ chiếu để nhập nhanh thông tin <span style={{ color: '#969696', fontSize: 12 }}> (không bắt buộc)</span>
                  </i>
                </div>
              </div>
            </Col>
            <Col xs={24}>
              <Form.Item name="insuredName" label="Họ và tên" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }]}>
                <Input
                  allowClear
                  placeholder="Nhập họ và tên"
                  onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "insuredName" })}
                />
              </Form.Item>
            </Col>
            {/* <Col xs={24}>
              <Form.Item name="insuredGender" label="Giới tính" rules={[{ required: true, message: 'Vui lòng chọn thông tin!' }]}>
                <Select
                  allowClear={isMobile ? false : true}
                  placeholder="Chọn giới tính"
                >
                  <Select.Option value={'MALE'}>
                    Nam
                  </Select.Option>
                  <Select.Option value={'FEMALE'}>
                    Nữ
                  </Select.Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col xs={24}>
              <Form.Item name="insuredDob" label="Ngày sinh" rules={[{ required: true, message: 'Vui lòng chọn thông tin!' }]}>
                <DatePicker
                  inputReadOnly
                  suffixIcon={<img src={Images.ICDate} />}
                  format={'DD/MM/YYYY'}
                  placeholder="DD/MM/YYYY"
                  disabledDate={disabledDate}
                  defaultPickerValue={idEdit !== undefined ? undefined : maxDate}
                  style={{ width: '100%' }}
                  onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "insuredDob" })}
                />
              </Form.Item>
              <i style={{ fontSize: 12, color: '#FB7800' }}>Độ tuổi từ 15 ngày tuổi đến 75 tuổi theo ngày sinh nhật</i>
            </Col>
            <Col xs={24}>
              <Form.Item name="insuredPrivateId" label="CCCD/ Số định danh" rules={[{ required: true, message: 'Vui lòng nhập thông tin!' }, {
                pattern: /^.{12,}$/,
                message: 'CCCD/ Số định danh chưa chính xác'
              }]}>
                <Input
                  allowClear
                  placeholder="Nhập CCCD/ Số định danh"
                  onBlur={() => trackProductEvent("product_insurance_field_input", { field_name: "insuredPrivateId" })}
                />
              </Form.Item>
              <i style={{ fontSize: 12, color: '#FB7800' }}>Đối với trẻ em điền số định danh</i>
            </Col>

            <Col xs={24}>
              <div style={{ padding: 10, background: '#FDF0F1', borderRadius: 8, color: '#FD1D1D', fontSize: 14 }}>
                Danh sách thành viên được bảo hiểm sẽ được áp dụng tại mục "<b>Thông tin cư trú</b>" trong <b>VNeID</b>.
              </div>
            </Col>

            <Form.Item style={{ display: 'none' }} name="privateIdUrl" label="link cccd" rules={[{ required: false, message: 'Vui lòng nhập thông tin!' }]}>
              <Input
                allowClear
                placeholder="Link CCcD"
              />
            </Form.Item>
            <Col xs={24}>
              <Button
                loading={loading}
                htmlType='submit'
                style={{ backgroundColor: '#009B4B', height: 44, width: '100%', fontWeight: 500, borderRadius: 8, fontSize: 16 }}
                type="primary">
                {idEdit !== undefined ? "Cập nhật" : "Thêm"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal >

      <style jsx>{`
        .card {
          background: #fff;
          border-radius: 16px;
          padding: 10px;
          box-shadow: 0px 0px 8px 0px #0000001a;
          display: grid;
          gap: 10px;
          border: 0.5px solid #d2d2d2;
        }

        .card-header {
          background: #f0f2f5;
          border-radius: 8px;
          padding: 10px;
          display: grid;
          gap: 10px;
        }

        .logo-box {
          background: #fff;
          border-radius: 8px;
          padding: 10px;
          width: 80px;
          height: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .logo-box img {
          object-fit: cover;
        }

        .card-body {
          width: 100%;
          display: grid;
          flex: 1;
          margin-top: -10px;
          margin-bottom: -10px
        }

        .title-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .title {
          font-size: 18px;
        }

        .info-row {
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .info-row.gray {
          color: #646d69;
          align-items: flex-start;
        }

        .highlight {
          color: #fb7800;
          font-weight: 600;
        }
      `}</style>
    </>
  );
}

export default AdAndEdit;
